import { MealCountKey, MealCountDto, IMealCountKey } from '.';

export class MealCountRequest {
  mealCountKeys: MealCountKey[] = [];

  constructor(mealCountKeys: MealCountKey[]) {
    if (mealCountKeys) {
      this.mealCountKeys = mealCountKeys;
    }
  }
}

export class CommonResult<T> {
  data!: T;
}

export class MealCountStatus implements IMealCountKey {
  constructor(
    public programId: string,
    public siteId: number,
    public mealTypeId: string,
    public mealServiceDate: string,
    public hasRecords: boolean,
    public hasAffirmedRevisions: boolean,
    public hasDraftRevisions: boolean
  ) {
    this.programId = programId;
    this.siteId = siteId;
    this.mealTypeId = mealTypeId;
    this.mealServiceDate = mealServiceDate;
    this.hasRecords = hasRecords;
    this.hasAffirmedRevisions = hasAffirmedRevisions;
    this.hasDraftRevisions = hasDraftRevisions;
  }
}

export class MealCountResult {
  counts!: MealCountDto[];
  countStatuses!: MealCountStatus[];
}
